import { CustomerDataEndpoint } from '../types';
import customerDataRequest from './fetch-customer-data';
import { setCustomerData, setCustomerDataError } from '@/store/actions';

export const fetchCustomerPackage = async () => {
  try {
    setCustomerData({ packageLoading: true });

    const data = await customerDataRequest(CustomerDataEndpoint.PACKAGE);

    setCustomerData({
      data,
    });
  } catch (error) {
    setCustomerDataError({
      type: 'CUSTOMER_PACKAGE',
      details: { ...(error as object) },
    });
  } finally {
    setCustomerData({
      packageLoading: false,
    });
  }
};
